import { useQuery } from '@tanstack/react-query';
import { Stack } from "@altimateai/lego";
import { Tooltip, Typography } from "@altimateai/lego";
import { getWarehouseLastEventTime } from "@/helpers/apis";
import { GET_LAST_UPDATED_TIME } from "../constants";
import WarehousePredefinedFilters from "./WarehousePredefinedFilters";
import dayjs from "dayjs";

const WarehouseHeader = () => {
  const { data: infoTimeString, isLoading } = useQuery({
    queryKey: [GET_LAST_UPDATED_TIME],
    queryFn: getWarehouseLastEventTime,
  });

  return (
    <>
      <Stack align={"center"} justify={"between"}>
        <Typography variant="page-heading">Infra</Typography>
        {!isLoading && infoTimeString && (
          <Typography variant="body" size="xs" className="al-text-slate-500">
            Last updated at{" "}
            <Tooltip title={dayjs(infoTimeString["timestamp"]).format("MMM, DD YY HH:mm:ss")}>
              <span className="al-text-slate-700 al-font-medium">
                {infoTimeString["time_string"]}
              </span>
            </Tooltip>{" "}
            UTC
          </Typography>
        )}
      </Stack>
      <Stack justify={"between"} align={"center"} gap={"lg"} className="al-py-3 al-rounded-t-md">
        <WarehousePredefinedFilters />
      </Stack>
    </>
  );
};

export default WarehouseHeader;
